interface IRD_FORMULA {
  monthlyDeposit: number;
  interestRate: number;
  noOfMonths: number;
  N?: number;
}
export function RD_FORMULA({
  monthlyDeposit,
  interestRate,
  noOfMonths,
  N = 4,
}: IRD_FORMULA) {
  const R = interestRate / 100;
  const tenureYears = noOfMonths / 12;
  let maturityValue = 0;
  let totalInterest = 0;

  for (let i = 1; i <= noOfMonths; i++) {
    const maturityAmount =
      monthlyDeposit * Math.pow(1 + R / N, N * (tenureYears - (i - 1) / 12));
    maturityValue += maturityAmount;
  }
  const depositedAmount = monthlyDeposit * noOfMonths;

  totalInterest = maturityValue - depositedAmount;

  return {
    totalInterest: totalInterest.toFixed(2),
    depositedAmount: depositedAmount.toFixed(2),
    maturityAmount: maturityValue.toFixed(2),
  };
}
